import { Lightning } from '@lightningjs/sdk';
import AbstractLoginSplitContent, {
  AbstractLoginSplitContentTemplateSpec,
} from '../layout/AbstractLoginSplitContent';
import EmailInputSection from './EmailInputSection';

export interface EmailInputContentTemplateSpec
  extends AbstractLoginSplitContentTemplateSpec {
  Content: {
    LeftSection: typeof EmailInputSection;
  } & AbstractLoginSplitContentTemplateSpec['Content'];
}

export default class EmailInputContent extends AbstractLoginSplitContent {
  static override _template(): Lightning.Component.Template<AbstractLoginSplitContentTemplateSpec> {
    const { Content } = super._template();

    return {
      Content: {
        ...Content,
        LeftSection: {
          type: EmailInputSection,
          passSignals: {
            $onEmailSubmit: '$onEmailSubmit',
            $onEmailInputHovered: '$onEmailInputHovered',
            $openKeyboard: true,
          },
        },
      },
    };
  }

  override _getFocused() {
    return this._LeftSection;
  }
}
